import src from "IMAGE";
export default { src, width: 181, height: 200, blurWidth: 7, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRnAAAABXRUJQVlA4TGQAAAAvBsABAM1VICICHgiADQIAAADrJeThKAEEAEAAPAAAAAAAAAAAAAAAAAAAEAAkAe5IoCoCoqujpWwAAICIyMEkoOOX1GknCITk4iAQ+N0/8bysvukuCB1y3z5ZJet83Pa0jDwC"};
